// @ts-nocheck

import CryptoJS from "crypto-js"
const ENCRYPTION = "";
const _encrypt = ({ data }) => {
	const encrypted = CryptoJS.AES.encrypt(data, ENCRYPTION.key, {
		iv: ENCRYPTION.iv
	}).toString()
	return encrypted
}

const _decrypt = ({ data }) => {
	const decoded = CryptoJS.enc.Base64.parse(data)
	const decrypted = CryptoJS.AES.decrypt({ ciphertext: decoded }, ENCRYPTION.key, {
		iv: ENCRYPTION.iv
	})
	return decrypted.toString(CryptoJS.enc.Utf8)
}

const parseJSON = (variable) => {
	if (typeof variable !== "string") return false

	try {
		return JSON.parse(variable)
	} catch (error) {
		return false
	}
}

const manageLocalStorage = (args) => {
	try {
		const { action, options, key, value } = args
		let ret

		if (action === "GET") {
			ret = localStorage.getItem(key)
			if (options?.includes("DECRYPT") && ret) ret = _decrypt({ data: ret })
			try {
				ret = parseJSON(ret) || ret
			} catch (err) {
				console.error(err)
			}
		} else if (action === "SET") {
			if (options?.includes("ENCRYPT")) ret = _encrypt({ data: value })
			else ret = JSON.stringify(value)

			localStorage.setItem(key, ret)
		} else if (action === "DELETE") {
			localStorage.removeItem(key)
		}

		return ret
	} catch (err) {
		console.error(err)
		return {}
	}
}

export default manageLocalStorage
